export default __webpack_public_path__ + "static/media/TAS.5af64834.jpg";